import {
  EnumColorStatusData,
  EnumStatusData,
} from '../../../../../base/domain/entities';

export function makeColorStatus(status) {
  if (status === EnumStatusData.active) return EnumColorStatusData.active;
  else if (status === EnumStatusData.inactive)
    return EnumColorStatusData.inactive;
  else if (status === EnumStatusData.in_process)
    return EnumColorStatusData.in_process;
  else if (status === EnumStatusData.cancel) return EnumColorStatusData.cancel;
  else if (status === EnumStatusData.closed) return EnumColorStatusData.closed;
  else if (status === EnumStatusData.waiting)
    return EnumColorStatusData.waiting;
  else if (status === EnumStatusData.pending)
    return EnumColorStatusData.pending;
  return '';
}

export function isScrollAtBottom({
  currentTarget,
}: React.UIEvent<HTMLDivElement>): boolean {
  return (
    currentTarget.scrollTop + 10 >=
    currentTarget.scrollHeight - currentTarget.clientHeight
  );
}
